export function toBase64(str) {
    try {
        let encoded = encodeURIComponent(str).replace(
            /%([0-9A-F]{2})/g,
            function (match, p1) {
                return String.fromCharCode("0x" + p1);
            }
        );
        return btoa(encoded);
    } catch (e) {
        console.error("Failed to encode Base64:", e);
        return null;
    }
}

export function fromBase64(base64) {
    try {
        let decoded = atob(base64);
        return decodeURIComponent(
            decoded
                .split("")
                .map(function (char) {
                    return (
                        "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2)
                    );
                })
                .join("")
        );
    } catch (e) {
        console.error("Failed to decode Base64:", e);
        return null;
    }
}

export function isBase64(str) {
    const base64Regex =
        /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/;
    return base64Regex.test(str);
}
